import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatSnackBar } from "@angular/material";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { AdminApi, ResourceApi, Translation } from "@app/shared/sdk";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import * as _ from "lodash";
import { ConfirmationDialogComponent } from "../../confirmation-dialog/confirmation-dialog.component";
import { GeneralSettingsService } from "../general-settings.service";
import { HelperService } from "@app/main/core/services/helper.service";
import { environment } from "@env/environment";
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "expansion-element",
  templateUrl: "./expansion-element.component.html",
  styleUrls: ["./expansion-element.component.scss"],
})
export class ExpansionElementComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string = "title";
  @Input("isColor") isColor: boolean = false;
  @Input() content: any = {
    type: "input",
    label: "",
    data: {
      key: "",
      value: "",
      iconUrl: "",
      category: { name: "", image: "", id: "" },
      type: "",
      file: {},
      isUpdated: false,
      colorMix: {
        flag: true,
        color1: "#000000",
        color2: "#000000",
        isUpdated: false,
      },
    },
    translation: {
      name: "",
      translationableId: "",
      translationableType: "",
      adminId: "",
      languageId: "",
      flag: true,
      isUpdated: false,
    },
  };
  @Input() isButton: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() readonly: boolean = false;
  @Input() languages: any;
  @Input() resourceName: string = "";

  @ViewChild("audioElement") audioElement: ElementRef;
  @ViewChild("languageName") languageName;

  translations = [];
  addLanguage: any = "None";
  selectedLanguage: any = "None";

  private _unsubscribeAll: Subject<any>;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fuseSplashScreenService: FuseSplashScreenService,
    private adminApi: AdminApi,
    private generalSettingsService: GeneralSettingsService,
    private domSanitizer: DomSanitizer,
    private cdref: ChangeDetectorRef,
    private _helperService: HelperService,
    private resourceApi: ResourceApi
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    if (this.content.data.type === "gameOver") {
      // console.log("getResourceImage()....", this.getResourceImage());
      // this.content.data.id = "";
      // this.content.data.value = "";
      // this.content.data.languageId =
      //   this.content.translation.translationableId = "";
    } else {
      this.content.data.value =
        this.content.data.value !== ""
          ? this.content.data.key === "automaticMessage" ||
            this.content.data.key === "automaticDonationMessage" ||
            this.content.data.key === "socialLoginPrompt"
            ? this._helperService.getValue(
              this.content.data.key,
              this.content.data.value,
              "decrypt"
            )
            : this.content.data.value
          : "";
      this.content.data.languageId =
        this.content.data.languageId === ""
          ? this.generalSettingsService.defaultLanguage.id
          : this.content.data.languageId;
    }

    // if (
    //   this.resourceName === "gameOverScreen" &&
    //   this.content &&
    //   this.content.data &&
    //   this.content.data.value !== ""
    // ) {
    //   this.content.data.value = "";
    //   console.log("getResourceImage()....", this.getResourceImage());
    // }
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  ngAfterViewInit() {
    this.generalSettingsService.onLanguagesChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((languages) => {
        this.languages = languages;
      });
  }

  /**
   *
   * @param $event
   * @param key
   * @param type
   */
  uploadResource($event, title, type) {
    if ($event && $event.target && $event.target.files.length !== 0) {
      let index = this.generalSettingsService.allResources[
        this.resourceName
      ].findIndex((el) => el.title === title);

      let reader = new FileReader();

      let file = $event.target.files[0];

      //if id is present in data only then isUpdated will be set to
      //true so no confusing occur between creation and updation
      this.generalSettingsService.allResources[this.resourceName][
        index
      ].content.data.isUpdated =
        this.generalSettingsService.allResources[this.resourceName][index]
          .content.data.id !== ""
          ? true
          : false;

      reader.readAsDataURL(file);
      if (file.type.indexOf("image") !== -1 && type === "image") {
        reader.onload = (_event) => {
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.file = file;
          if (this.resourceName === "categories") {
            this.generalSettingsService.allResources[this.resourceName][
              index
            ].content.data.category.image = reader.result;
          } else if (this.resourceName === "language") {
            this.generalSettingsService.allResources[this.resourceName][
              index
            ].content.data.iconUrl = reader.result;
            this.generalSettingsService.allResources.language[2].content.data.value.iconUrl =
              reader.result;
          } else if (this.resourceName === "gameOverScreen") {
            this.generalSettingsService.allResources[this.resourceName][
              index
            ].content.data.value = reader.result;
            this.generalSettingsService.allResources[this.resourceName][
              index
            ].content.data.languageId =
              this.generalSettingsService.selectedLanguage !== null &&
                this.generalSettingsService.selectedLanguage !== "None"
                ? this.generalSettingsService.selectedLanguage.id
                : this.generalSettingsService.defaultLanguage !== null
                  ? this.generalSettingsService.defaultLanguage.id
                  : null;
          } else {
            this.generalSettingsService.allResources[this.resourceName][
              index
            ].content.data.value = reader.result;
          }
        };
      } else if (file.type.indexOf("audio") !== -1 && type === "audio") {
        reader.onload = (_event) => {
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.file = file;

          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.value = this.sanitizeUrl(reader.result);
          this.audioElement.nativeElement.load();
        };
      } else {
        this.snackBar.open(`Please select ${type} and try again!`, "ERROR", {
          verticalPosition: "top",
          duration: 3000,
        });
      }
    }
  }

  onInputChange($event, title) {
    // substringsArray.some(substring => yourBigString.includes(substring))
    let index = this.generalSettingsService.allResources[
      this.resourceName
    ].findIndex((el) => el.title === title);

    // when some rewardPoints were updated then it will reflect in messages with dynamic points
    if (this.resourceName === "rewardPoints") {
      let key =
        this.generalSettingsService.allResources[this.resourceName][index]
          .content.data.key;
      let i = this.generalSettingsService.allResources.messages.findIndex(
        (el) => el.content.data.key.includes(key)
      );

      if (
        i !== 0 &&
        this.generalSettingsService.allResources.messages[i] &&
        this.generalSettingsService.allResources.messages[i].content &&
        this.generalSettingsService.allResources.messages[i].content
          .endTextOfMsg
      ) {
        let endTextOfMsg =
          this.generalSettingsService.allResources.messages[i].content
            .endTextOfMsg;
        this.generalSettingsService.allResources.messages[
          i
        ].content.data.value =
          $event !== `` ? `You need ${$event} coins to ${endTextOfMsg}` : ``;

        this.generalSettingsService.allResources[this.resourceName][
          i
        ].content.data.isUpdated =
          this.generalSettingsService.allResources[this.resourceName][i].content
            .data.id !== "" && $event !== ""
            ? true
            : false;
      }
    }

    this.generalSettingsService.allResources[this.resourceName][
      index
    ].content.data.isUpdated =
      this.generalSettingsService.allResources[this.resourceName][index].content
        .data.id
        ? true
        : this.generalSettingsService.allResources[this.resourceName][index]
          .content.data.id === "" && $event !== ""
          ? true
          : false;
    this.generalSettingsService.allResources[this.resourceName][
      index
    ].content.data.value = $event;
  }

  onTranslationInputChange($event, title) {
    let index = this.generalSettingsService.allResources[
      this.resourceName
    ].findIndex((el) => el.title === title);
    let data =
      this.generalSettingsService.allResources[this.resourceName][index];
    data.content.translation.isUpdated = true;
    data.content.translation.name = $event;
    if (!data.content.translation.translationableId && data.content.data && data.content.data.id) {
      data.content.translation.translationableId = data.content.data.id;
    }
  }

  mappingTranslations(resourceName: string): any[] {
    if (resourceName === "messages") {
      return this.generalSettingsService.allResources[resourceName].map((el) =>
        el.content.data.key === "automaticMessage" ||
          el.content.data.key === "automaticDonationMessage" ||
          el.content.data.key === "socialLoginPrompt"
          ? this._helperService.getValue(
            el.content.data.key,
            el.content.data.value,
            "encrypt"
          )
          : el.content.data.value
      );
    } else {
      return this.generalSettingsService.allResources[resourceName].map(
        (el) => el.title
      );
    }
  }

  patchingTranslations() {
    this.generalSettingsService.resourceNamesForTranslation
      .filter((el) => el !== "gameOverScreen")
      .forEach((el) => {
        this.translations
          .splice(0, this.generalSettingsService.allResources[el].length)
          .forEach((translation, index) => {
            let key =
              this.generalSettingsService.allResources[el][index].content.data
                .key;
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.id = "";
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.name =
              key === "automaticMessage"
                ? this._helperService.getValue(key, translation, "decrypt")
                : key === "automaticDonationMessage"
                  ? this._helperService.getValue(key, translation, "decrypt")
                  : key === "socialLoginPrompt"
                    ? this._helperService.getValue(key, translation, "decrypt")
                    : translation;
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.isUpdated = true;
          });
      });
  }

  checkingIfTranslatableResourcesPresentOrNot(): number {
    let count = 0;
    this.generalSettingsService.resourceNamesForTranslation
      .filter((el) => el !== "gameOverScreen")
      .forEach((el) => {
        count =
          this.generalSettingsService.allResources[el].filter(
            (el) =>
              el.content.data.id === "" &&
              el.content.data.value === "" &&
              el.content.translation.flag
          ).length !== 0
            ? count + 1
            : count;
      });
    return count;
  }

  removingLanguageWithGameOverScreenData() {
    // removing language
    this.generalSettingsService.allResources[
      this.resourceName
    ][2].content.data.value = "";
    this.generalSettingsService.allResources.language[0].content.data.value =
      "";
    // removing gameOverScreen content
    // this.generalSettingsService.allResources.gameOverScreen[1].content.data.value =
    //   "";
    // this.generalSettingsService.allResources.gameOverScreen[0].content.data.value =
    //   "";

    this.selectedLanguage = "None";
  }

  /**
   *
   * @param langValue
   * @param type
   * @param title
   */
  onClickUpdateTranslations = async (
    langValue: any,
    type: string,
    title: string
  ) => {
    if (langValue === "None") {
      this.fuseSplashScreenService.show();
      if (type === "add_lang") {
        this.addLanguage = langValue;
      } else {
        this.selectedLanguage = langValue;
      }
      try {
        let resource: any = await this.resourceApi
          .find({
            where: {
              or: [{ key: "gameOverSound" }, { key: "gameOverImage" }, { key: "enterToWinImage" }, { key: "orEnterToWinImage" }],
              languageId: null,
            },
          })
          .toPromise();
        this.fuseSplashScreenService.hide();
        if (!resource) return;
        if (resource[0].key === "gameOverImage") {
          this.generalSettingsService.allResources.gameOverScreen[0].content.data.id =
            resource[0].id;
          this.generalSettingsService.allResources.gameOverScreen[0].content.data.languageId =
            resource[0].languageId;
          this.generalSettingsService.allResources.gameOverScreen[0].content.data.value =
            resource[0].value;
        } else if (resource[1].key === "gameOverSound") {
          this.generalSettingsService.allResources.gameOverScreen[1].content.data.id =
            resource[1].id;
          this.generalSettingsService.allResources.gameOverScreen[1].content.data.languageId =
            resource[1].languageId;
          this.generalSettingsService.allResources.gameOverScreen[1].content.data.value =
            resource[1].value;
        }
        const messagesList = this.generalSettingsService.allResources.messages;
        const enterToWinMsg = messagesList && messagesList.find(
          (m: any) => m && m.content && m.content.data && m.content.data.key === "enterToWinImage"
        );
        if (enterToWinMsg && enterToWinMsg.content && enterToWinMsg.content.data) {
          enterToWinMsg.content.data.id = "";
          enterToWinMsg.content.data.languageId = "";
          enterToWinMsg.content.data.value = "";
        }

        const orEnterToWinMsg = messagesList && messagesList.find(
          (m: any) => m && m.content && m.content.data && m.content.data.key === "orEnterToWinImage"
        );
        if (orEnterToWinMsg && orEnterToWinMsg.content && orEnterToWinMsg.content.data) {
          orEnterToWinMsg.content.data.id = "";
          orEnterToWinMsg.content.data.languageId = "";
          orEnterToWinMsg.content.data.value = "";
        }
        this.cdref.detectChanges();
      } catch (error) {
        this.fuseSplashScreenService.hide();
        console.log("error....", error);
      }
      this.removingLanguageWithGameOverScreenData();
      this.removeTranslations();
    } else {
      // getting index number of this specific title
      let index = this.generalSettingsService.allResources[
        this.resourceName
      ].findIndex((el) => el.title === title);

      if (this.languages.filter((el) => !el.id).length !== 0) {
        //poping language item if its being replaced
        this.languages.pop();
      }
      if (
        type === "add_lang" &&
        this.languages.filter((el) => el.name === langValue.name).length === 0
      ) {
        // if all resources are not uploaded before adding language with translation this alert will popup
        if (this.checkingIfTranslatableResourcesPresentOrNot() !== 0) {
          this.addLanguage = "None";
          alert(
            "Please add resources for all translation fields, and then try adding a language again!"
          );
        } else {
          this.fuseSplashScreenService.show();

          this.removeTranslations();

          this.selectedLanguage = "None";
          this.addLanguage = langValue;

          this.generalSettingsService.allResources[
            this.resourceName
          ][0].content.data.value = langValue.name;

          // setting value on language icon on global array of allResources
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.adminId = this.adminApi.getCurrentId();
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.name = langValue.name;
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.adminId = this.adminApi.getCurrentId();
          this.generalSettingsService.allResources[this.resourceName][
            index
          ].content.data.code = langValue.code;

          // mapping translations from global allResources into string[] to send to google api to translate
          this.translations = this.mappingTranslations("messages")
            .concat(this.mappingTranslations("profile"))
            .concat(this.mappingTranslations("settings"))
            .concat(this.mappingTranslations("marketplace"))
            .concat(this.mappingTranslations("gameButtons"))
            .concat(this.mappingTranslations("words"))
            .concat(this.mappingTranslations("splashScreens"))
            .concat(this.mappingTranslations("categories"));

          try {
            const translationResponse: any = await this.generalSettingsService
              .translatingFromGoogle(
                this.translations,
                langValue && langValue.code
                  ? langValue.code
                  : langValue.language
              )
              .toPromise();
            this.fuseSplashScreenService.hide();
            if (!translationResponse) return;

            this.translations = translationResponse.map(
              (translation) => translation
            );
            this.patchingTranslations();
            this.removingLanguageWithGameOverScreenData();

            this.generalSettingsService.allResources[
              this.resourceName
            ][2].content.data.value = langValue.name;
          } catch (error) {
            this.fuseSplashScreenService.hide();
            if (error.error && error.error.error.message)
              this.snackBar.open(error.error.error.message, "Cancel", {
                verticalPosition: "top",
                duration: 3000,
              });
            return error;
          }
        }
      } else if (type === "select_lang") {
        /**
         * removing Language icon image
         */
        this.generalSettingsService.allResources[
          this.resourceName
        ][1].content.data.file = {};
        this.generalSettingsService.allResources[
          this.resourceName
        ][1].content.data.iconUrl = "";
        this.generalSettingsService.allResources[
          this.resourceName
        ][1].content.data.value = "";

        this.selectedLanguage = langValue;
        this.generalSettingsService.selectedLanguage = _.cloneDeep(
          this.selectedLanguage
        );

        this.fuseSplashScreenService.show();
        await this.generalSettingsService
          .getTranslationWithLangId(langValue.id)
          .then(
            (response) => {
              this.patchTranslations(response.translations, langValue.id);

              if (response.resources && response.resources.length !== 0) {
                response.resources.forEach((resource: any) => {
                  const { key, id, languageId, value } = resource;
                  let target;

                  switch (key) {
                    case "gameOverImage":
                      target =
                        this.generalSettingsService.allResources
                          .gameOverScreen[0].content.data;
                      break;
                    case "gameOverSound":
                      target =
                        this.generalSettingsService.allResources
                          .gameOverScreen[1].content.data;
                      break;
                    case "enterToWinImage": {
                      const enterToWinMsg =
                        this.generalSettingsService.allResources.messages &&
                        this.generalSettingsService.allResources.messages.find(
                          (m: any) => m && m.content && m.content.data && m.content.data.key === "enterToWinImage"
                        );
                      target =
                        enterToWinMsg &&
                        enterToWinMsg.content &&
                        enterToWinMsg.content.data;
                      break;
                    }
                    case "orEnterToWinImage": {
                      const orEnterToWinMsg =
                        this.generalSettingsService.allResources.messages &&
                        this.generalSettingsService.allResources.messages.find(
                          (m: any) => m && m.content && m.content.data && m.content.data.key === "orEnterToWinImage"
                        );
                      target =
                        orEnterToWinMsg &&
                        orEnterToWinMsg.content &&
                        orEnterToWinMsg.content.data;
                      break;
                    }
                    default:
                      target = null;
                  }

                  if (target) {
                    target.id = id;
                    target.languageId = languageId;
                    target.value = value;
                  }
                });

                this.cdref.detectChanges();
              } else {
                const emptyData = { id: "", languageId: "", value: "" };

                const gameOver0 =
                  this.generalSettingsService.allResources.gameOverScreen &&
                  this.generalSettingsService.allResources.gameOverScreen[0] &&
                  this.generalSettingsService.allResources.gameOverScreen[0].content &&
                  this.generalSettingsService.allResources.gameOverScreen[0].content.data;

                const gameOver1 =
                  this.generalSettingsService.allResources.gameOverScreen &&
                  this.generalSettingsService.allResources.gameOverScreen[1] &&
                  this.generalSettingsService.allResources.gameOverScreen[1].content &&
                  this.generalSettingsService.allResources.gameOverScreen[1].content.data;

                const enterMsg =
                  this.generalSettingsService.allResources.messages &&
                  this.generalSettingsService.allResources.messages.find(
                    (m: any) => m && m.content && m.content.data && m.content.data.key === "enterToWinImage"
                  );
                const enterData = enterMsg && enterMsg.content && enterMsg.content.data;

                const orEnterMsg =
                  this.generalSettingsService.allResources.messages &&
                  this.generalSettingsService.allResources.messages.find(
                    (m: any) => m && m.content && m.content.data && m.content.data.key === "orEnterToWinImage"
                  );
                const orEnterData = orEnterMsg && orEnterMsg.content && orEnterMsg.content.data;

                [gameOver0, gameOver1, enterData, orEnterData].forEach((target) => {
                  if (target) {
                    target.id = emptyData.id;
                    target.languageId = emptyData.languageId;
                    target.value = emptyData.value;
                  }
                });
              }

              this.generalSettingsService.allResources[
                this.resourceName
              ][2].content.data.value = langValue;
              this.fuseSplashScreenService.hide();
            },
            (error) => {
              console.log(error);
              this.fuseSplashScreenService.hide();
            }
          );
      } else {
        alert("Language already exists");
      }
    }
  };

  checkIfLangIsSelected(): boolean {
    return this.generalSettingsService.allResources.language[0].content.data
      .value !== "" ||
      this.generalSettingsService.allResources.language[2].content.data
        .value !== ""
      ? false
      : true;
  }

  removeTranslations() {
    Object.keys(this.generalSettingsService.allResources)
      .filter((el) => el !== "language")
      .forEach((el) => {
        this.generalSettingsService.allResources[el].forEach(
          (iterator, index) => {
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.id = "";
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.name = "";
            this.generalSettingsService.allResources[el][
              index
            ].content.translation.languageId = "";
          }
        );
      });
  }

  patchTranslations(translations: Translation[], languageId?) {
    let index = -1;

    let categoriesTranslations = translations.filter(
      (el) => el.translationableType === "GameCategory"
    );

    let resourcesTranslations = translations.filter(
      (el) => el.translationableType === "Resource"
    );

    let resourceNamesForTranslation = _.cloneDeep(
      this.generalSettingsService.resourceNamesForTranslation.filter(
        (el) => el !== "categories"
      )
    );

    this.generalSettingsService.allResources.categories.forEach((field, i) => {
      index = categoriesTranslations.findIndex(
        (translation) =>
          translation.translationableId === field.content.data.category.id
      );
      if (index !== -1)
        this.updateTransaltion(
          "categories",
          i,
          categoriesTranslations[index],
          languageId
        );
      else this.updateTransaltion("categories", i, null, languageId);
    });

    resourceNamesForTranslation.forEach((resourceName) => {
      this.generalSettingsService.allResources[resourceName].forEach(
        (field, i) => {
          index = resourcesTranslations.findIndex(
            (translation) =>
              (field.content.data && field.content.data.id && translation.translationableId === field.content.data.id) ||
              (field.content.translation && field.content.translation.translationableId && translation.translationableId === field.content.translation.translationableId)
          );
          if (index !== -1)
            this.updateTransaltion(
              resourceName,
              i,
              resourcesTranslations[index],
              languageId
            );
          else this.updateTransaltion(resourceName, i, null, languageId);
        }
      );
    });
  }

  updateTransaltion(element, index, translation?, languageId?) {
    let resource = this.generalSettingsService.allResources[element][index];

    let key = resource.content.data.key;

    if (resource && resource.content) {
      resource.content.translation.id =
        translation && translation.id ? translation.id : "";

      resource.content.translation.name =
        translation && translation.name
          ? key === "automaticMessage"
            ? this._helperService.getValue(key, translation.name, "decrypt")
            : key === "automaticDonationMessage"
              ? this._helperService.getValue(key, translation.name, "decrypt")
              : key === "socialLoginPrompt"
                ? this._helperService.getValue(key, translation.name, "decrypt")
                : translation.name
          : "";

      resource.content.translation.translationableId =
        translation && translation.translationableId
          ? translation.translationableId
          : resource.content.data && resource.content.data.id
            ? resource.content.data.id
            : resource.content.data && resource.content.data.category
              ? resource.content.data.category.id
              : "";

      resource.content.translation.adminId =
        translation && translation.adminId ? translation.adminId : "";

      const activeLangId =
        languageId
          ? languageId
          : this.selectedLanguage && this.selectedLanguage.id
            ? this.selectedLanguage.id
            : this.generalSettingsService.selectedLanguage && this.generalSettingsService.selectedLanguage.id
              ? this.generalSettingsService.selectedLanguage.id
              : "";

      resource.content.translation.languageId =
        translation && translation.languageId
          ? translation.languageId
          : activeLangId;
    }
  }

  getResourceImage(): string {
    if (
      this.content.data &&
      this.content.data.category &&
      this.content.data.category.image
    ) {
      if (this.content.data.category.image.indexOf("data:") !== -1) {
        return this.content.data.category.image;
      } else return environment.s3BucketUrl + this.content.data.category.image;
    } else if (this.content.data && this.content.data.value) {
      if (this.content.data.value.toString().indexOf("https") !== -1) {
        return this.content.data.value;
      } else if (this.content.data.value.toString().indexOf("data:") !== -1) {
        return this.content.data.value;
      } else return `${environment.s3BucketUrl}${this.content.data.value}`;
    } else if (this.content.data && this.content.data.iconUrl) {
      return this.content.data.iconUrl;
    } else {
      return "/assets/images/image-not-found-150x150.png";
    }
  }

  getResourceAudio(audioSrc): string {
    if (audioSrc.indexOf("data:") !== -1) {
      return audioSrc;
    } else
      return (
        environment.s3BucketUrl + audioSrc.replace(environment.s3BucketUrl)
      );
  }

  getLanguages = (content, languages): any[] => {
    return content.data.languages && content.data.languages.length !== 0
      ? content.data.languages
      : languages;
  };

  /**
   * sanitizing the url if its unsafe to preview on DOM
   * @param url
   * @returns
   */
  sanitizeUrl(url): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }

  deleteLanguage = (event, lang) => {
    event.preventDefault();
    event.stopPropagation();
    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to Delete?",
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(async (result) => {
        if (!result) return;

        this.fuseSplashScreenService.show();

        try {
          await this.generalSettingsService
            .deleteLanguageAndTranslations(lang.id)
            .toPromise();
          this.fuseSplashScreenService.hide();

          this.languages = [
            ...this.languages.filter((el) => el.id !== lang.id),
          ];
          this.generalSettingsService.onLanguagesChanged.next(this.languages);
          this.snackBar.open("Language deleted successfully!", "OK", {
            verticalPosition: "top",
            duration: 2000,
          });
          this.languageName.close();
        } catch (error) {
          this.fuseSplashScreenService.hide();
          console.log(error);
          return error;
        }
      });
  };
}
